import type { BaseOptions } from "./internal/types";
import type { CorrectComponentType, Format } from "../utils/index";
import type { Path } from "./internal";

import html from "solid-js/html";
import { Show } from "solid-js";

export const makePathDataComponent = <RootData = any, Props = any>({
  useRootData,
  hooks,
  name,
}: BaseOptions<RootData>): CorrectComponentType<
  { propertyName: Path<RootData>; format?: Format } & Props
> => {
  const { usePath, useFormattedValue } = hooks;
  return (props, { element }) => {
    if (!props.propertyName)
      return console.warn(
        `${name}: No property-name attribute provided.`,
        element,
      );
    const data = useRootData(element);
    const fullPath = usePath({
      element,
      path: () => props.propertyName,
    });
    const formattedValue = useFormattedValue({
      get format() {
        return props.format;
      },
      path: fullPath,
      data: data as any,
    });
    return html`
      <${Show} when=${() => formattedValue() !== null}> ${formattedValue} <//>
    `;
  };
};
